import React, { PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import cx from 'classnames';

const renderDefault = () => (
  <div className="default text">Choisissez un client</div>
);

const renderCustomer = customer => (
  <div key={customer.id} data-value={customer.id} className="item">
    {customer.name}
  </div>
);

export const CustomerSelector = ({
  customerId,
  customerChoice,
  onChange,
  errors,
}) => {
  const fieldClass = cx('field required', {
    error: errors.includes('customerId'),
  });

  const sortCustomers = (l, r) => {
    const lname = l.name.toLowerCase();
    const rname = r.name.toLowerCase();
    if (lname > rname) {
      return 1;
    } else if (lname < rname) {
      return -1;
    }
    return 0;
  };

  const filteredChoices = customerChoice.filter(
    c => c.deleted === false || c.id === customerId
  );
  const customers = filteredChoices.sort(sortCustomers);

  return (
    <div className={fieldClass}>
      <label>1- Choisir le nouveau client</label>
      <Dropdown
        name="ref_tech_id"
        value={customerId}
        items={customers}
        renderDefault={renderDefault}
        renderItem={renderCustomer}
        onChange={onChange}
        search
      />
    </div>
  );
};

CustomerSelector.propTypes = {
  customerId: PropTypes.string,
  customerChoice: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/components/CustomerSelector.js